import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import CountryList from 'components/system/country/CountryList';
import CountryForm from 'components/system/country/CountryForm';


export default function Country({ match }) {
    return (
        <RouteMenu match={match} indexComponent={CountryList}>
            <Route path={path.join(match.url, 'new')} component={CountryForm} />
            <Route path={path.join(match.url, 'edit/:id')} component={CountryForm} />
        </RouteMenu>
    );
}